import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './_styles.scss'

class LayoutTwoChannel extends Component {
  render() {
    const { groups = {} } = this.props;

    const poster1 = groups[0] || {};
    const poster2 = groups[1] || {};

    return (
      <div className="layout-two-channel">
        <div className="layout-two-channel__row">
          <div className='layout-two-channel__poster'>
            <img 
              src={poster1.images.square} 
              alt={poster1.title} 
            />
          </div>

          <div className='layout-two-channel__poster'>
            <img 
              src={poster2.images.square} 
              alt={poster2.title} 
            />
          </div>
        </div>
      </div>
    );
  }
}

LayoutTwoChannel.propTypes = {
  groups: PropTypes.array,
};

LayoutTwoChannel.defaultProps = {
  groups: [],
};

export default LayoutTwoChannel;



// WEBPACK FOOTER //
// ./src/payments/DetailSelector/LandingComercialChannels/Components/LayoutTwoChannel/index.jsx